import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.handleScroll = this.onScroll.bind(this)
    window.addEventListener("scroll", this.handleScroll, { passive: true })
    this.onScroll()
  }

  disconnect() {
    window.removeEventListener("scroll", this.handleScroll)
  }

  onScroll() {
    if (window.scrollY > 50) {
      this.element.classList.add("nav--scrolled")
    } else {
      this.element.classList.remove("nav--scrolled")
    }
  }

  toggle() {
    const links = this.element.querySelector(".nav__links")
    if (links) {
      links.classList.toggle("nav__links--open")
    }
  }
}
